(function () {
  window.CDX_MV_VERSION = '23';
  var CFG = window.CDX_MAIL_VALIDATION || {};
  var T = CFG.texts || {};

  var SEL_EMAIL = [
    'input[type="email"]',
    'input[inputmode="email"]',
    'input[name="contact[email]"]',
    'input[name*="email" i]',
    'input[id*="email" i]',
    'input[data-testid*="email" i]',
    'input[autocomplete="email"]'
  ].join(', ');

  var SEL_PHONE = [
    'input[type="tel"]',
    'input[inputmode="tel"]',
    'input[name="contact[phone]"]',
    'input[name="contact[Telefon]"]',
    'input[name*="phone" i]',
    'input[name*="telefon" i]',
    'input[id*="phone" i]',
    'input[id*="telefon" i]',
    'input[data-testid*="phone" i]',
    'input[autocomplete="tel"]'
  ].join(', ');

  var SEL_ZIP = [
    'input[name="contact[Postleitzahl]"]',
    'input[name="contact[zip]"]',
    'input[name="contact[PLZ]"]',
    'input[name*="postal" i]',
    'input[id*="postal" i]',
    'input[id*="zipcode" i]',
    'input[data-testid*="postal" i]',
    'input[autocomplete="postal-code"]'
  ].join(', ');

  var SEL_NAME = [
    'input[name="contact[name]"]',
    'input[name="contact[Vorname]"]',
    'input[name="contact[Nachname]"]',
    'input[id="name"]',
    'input[id*="firstname" i]',
    'input[id*="lastname" i]',
    'input[data-testid="field-name"]',
    'input[autocomplete="given-name"]',
    'input[autocomplete="family-name"]',
    'input[autocomplete="name"]'
  ].join(', ');

  var TLD_SET = new Set("aaa|aarp|abb|abbott|abbvie|abc|able|abogado|abudhabi|ac|academy|accenture|accountant|accountants|aco|actor|ad|ads|adult|ae|aeg|aero|aetna|af|afl|africa|ag|agakhan|agency|ai|aig|airbus|airforce|airtel|akdn|al|alibaba|alipay|allfinanz|allstate|ally|alsace|alstom|am|amazon|americanexpress|americanfamily|amex|amfam|amica|amsterdam|analytics|android|anquan|anz|ao|aol|apartments|app|apple|aq|aquarelle|ar|arab|aramco|archi|army|arpa|art|arte|as|asda|asia|associates|at|athleta|attorney|au|auction|audi|audible|audio|auspost|author|auto|autos|aw|aws|ax|axa|az|azure|ba|baby|baidu|banamex|band|bank|bar|barcelona|barclaycard|barclays|barefoot|bargains|baseball|basketball|bauhaus|bayern|bb|bbc|bbt|bbva|bcg|bcn|bd|be|beats|beauty|beer|berlin|best|bestbuy|bet|bf|bg|bh|bharti|bi|bible|bid|bike|bing|bingo|bio|biz|bj|black|blackfriday|blockbuster|blog|bloomberg|blue|bm|bms|bmw|bn|bnpparibas|bo|boats|boehringer|bofa|bom|bond|boo|book|booking|bosch|bostik|boston|bot|boutique|box|br|bradesco|bridgestone|broadway|broker|brother|brussels|bs|bt|build|builders|business|buy|buzz|bv|bw|by|bz|bzh|ca|cab|cafe|cal|call|calvinklein|cam|camera|camp|canon|capetown|capital|capitalone|car|caravan|cards|care|career|careers|cars|casa|case|cash|casino|cat|catering|catholic|cba|cbn|cbre|cc|cd|center|ceo|cern|cf|cfa|cfd|cg|ch|chanel|channel|charity|chase|chat|cheap|chintai|christmas|chrome|church|ci|cipriani|circle|cisco|citadel|citi|citic|city|ck|cl|claims|cleaning|click|clinic|clinique|clothing|cloud|club|clubmed|cm|cn|co|coach|codes|coffee|college|cologne|com|commbank|community|company|compare|computer|comsec|condos|construction|consulting|contact|contractors|cooking|cool|coop|corsica|country|coupon|coupons|courses|cpa|cr|credit|creditcard|creditunion|cricket|crown|crs|cruise|cruises|cu|cuisinella|cv|cw|cx|cy|cymru|cyou|cz|dad|dance|data|date|dating|datsun|day|dclk|dds|de|deal|dealer|deals|degree|delivery|dell|deloitte|delta|democrat|dental|dentist|desi|design|dev|dhl|diamonds|diet|digital|direct|directory|discount|discover|dish|diy|dj|dk|dm|dnp|do|docs|doctor|dog|domains|dot|download|drive|dtv|dubai|dupont|durban|dvag|dvr|dz|earth|eat|ec|eco|edeka|edu|education|ee|eg|email|emerck|energy|engineer|engineering|enterprises|epson|equipment|er|ericsson|erni|es|esq|estate|et|eu|eurovision|eus|events|exchange|expert|exposed|express|extraspace|fage|fail|fairwinds|faith|family|fan|fans|farm|farmers|fashion|fast|fedex|feedback|ferrari|ferrero|fi|fidelity|fido|film|final|finance|financial|fire|firestone|firmdale|fish|fishing|fit|fitness|fj|fk|flickr|flights|flir|florist|flowers|fly|fm|fo|foo|food|football|ford|forex|forsale|forum|foundation|fox|fr|free|fresenius|frl|frogans|frontier|ftr|fujitsu|fun|fund|furniture|futbol|fyi|ga|gal|gallery|gallo|gallup|game|games|gap|garden|gay|gb|gbiz|gd|gdn|ge|gea|gent|genting|george|gf|gg|ggee|gh|gi|gift|gifts|gives|giving|gl|glass|gle|global|globo|gm|gmail|gmbh|gmo|gmx|gn|godaddy|gold|goldpoint|golf|goo|goodyear|goog|google|gop|got|gov|gp|gq|gr|grainger|graphics|gratis|green|gripe|grocery|group|gs|gt|gu|gucci|guge|guide|guitars|guru|gw|gy|hair|hamburg|hangout|haus|hbo|hdfc|hdfcbank|health|healthcare|help|helsinki|here|hermes|hiphop|hisamitsu|hitachi|hiv|hk|hkt|hm|hn|hockey|holdings|holiday|homedepot|homegoods|homes|homesense|honda|horse|hospital|host|hosting|hot|hotels|hotmail|house|how|hr|hsbc|ht|hu|hughes|hyatt|hyundai|ibm|icbc|ice|icu|id|ie|ieee|ifm|ikano|il|im|imamat|imdb|immo|immobilien|in|inc|industries|infiniti|info|ing|ink|institute|insurance|insure|int|international|intuit|investments|io|ipiranga|iq|ir|irish|is|ismaili|ist|istanbul|it|itau|itv|jaguar|java|jcb|je|jeep|jetzt|jewelry|jio|jll|jm|jmp|jnj|jo|jobs|joburg|jot|joy|jp|jpmorgan|jprs|juegos|juniper|kaufen|kddi|ke|kerryhotels|kerryproperties|kfh|kg|kh|ki|kia|kids|kim|kindle|kitchen|kiwi|km|kn|koeln|komatsu|kosher|kp|kpmg|kpn|kr|krd|kred|kuokgroup|kw|ky|kyoto|kz|la|lacaixa|lamborghini|lamer|land|landrover|lanxess|lasalle|lat|latino|latrobe|law|lawyer|lb|lc|lds|lease|leclerc|lefrak|legal|lego|lexus|lgbt|li|lidl|life|lifeinsurance|lifestyle|lighting|like|lilly|limited|limo|lincoln|link|live|living|lk|llc|llp|loan|loans|locker|locus|lol|london|lotte|lotto|love|lpl|lplfinancial|lr|ls|lt|ltd|ltda|lu|lundbeck|luxe|luxury|lv|ly|ma|madrid|maif|maison|makeup|man|management|mango|map|market|marketing|markets|marriott|marshalls|mattel|mba|mc|mckinsey|md|me|med|media|meet|melbourne|meme|memorial|men|menu|merckmsd|mg|mh|miami|microsoft|mil|mini|mint|mit|mitsubishi|mk|ml|mlb|mls|mm|mma|mn|mo|mobi|mobile|moda|moe|moi|mom|monash|money|monster|mormon|mortgage|moscow|moto|motorcycles|mov|movie|mp|mq|mr|ms|msd|mt|mtn|mtr|mu|museum|music|mv|mw|mx|my|mz|na|nab|nagoya|name|navy|nba|nc|ne|nec|net|netbank|netflix|network|neustar|new|news|next|nextdirect|nexus|nf|nfl|ng|ngo|nhk|ni|nico|nike|nikon|ninja|nissan|nissay|nl|no|nokia|norton|now|nowruz|nowtv|np|nr|nra|nrw|ntt|nu|nyc|nz|obi|observer|office|okinawa|olayan|olayangroup|ollo|om|omega|one|ong|onl|online|ooo|open|oracle|orange|org|organic|origins|osaka|otsuka|ott|ovh|pa|page|panasonic|paris|pars|partners|parts|party|pay|pccw|pe|pet|pf|pfizer|pg|ph|pharmacy|phd|philips|phone|photo|photography|photos|physio|pics|pictet|pictures|pid|pin|ping|pink|pioneer|pizza|pk|pl|place|play|playstation|plumbing|plus|pm|pn|pnc|pohl|poker|politie|porn|post|pr|praxi|press|prime|pro|prod|productions|prof|progressive|promo|properties|property|protection|pru|prudential|ps|pt|pub|pw|pwc|py|qa|qpon|quebec|quest|racing|radio|re|read|realestate|realtor|realty|recipes|red|redumbrella|rehab|reise|reisen|reit|reliance|ren|rent|rentals|repair|report|republican|rest|restaurant|review|reviews|rexroth|rich|richardli|ricoh|ril|rio|rip|ro|rocks|rodeo|rogers|room|rs|rsvp|ru|rugby|ruhr|run|rw|rwe|ryukyu|sa|saarland|safe|safety|sakura|sale|salon|samsclub|samsung|sandvik|sandvikcoromant|sanofi|sap|sarl|sas|save|saxo|sb|sbi|sbs|sc|scb|schaeffler|schmidt|scholarships|school|schule|schwarz|science|scot|sd|se|search|seat|secure|security|seek|select|sener|services|seven|sew|sex|sexy|sfr|sg|sh|shangrila|sharp|shell|shia|shiksha|shoes|shop|shopping|shouji|show|si|silk|sina|singles|site|sj|sk|ski|skin|sky|skype|sl|sling|sm|smart|smile|sn|sncf|so|soccer|social|softbank|software|sohu|solar|solutions|song|sony|soy|spa|space|sport|spot|sr|srl|ss|st|stada|staples|star|statebank|statefarm|stc|stcgroup|stockholm|storage|store|stream|studio|study|style|su|sucks|supplies|supply|support|surf|surgery|suzuki|sv|swatch|swiss|sx|sy|sydney|systems|sz|tab|taipei|talk|taobao|target|tatamotors|tatar|tattoo|tax|taxi|tc|tci|td|tdk|team|tech|technology|tel|temasek|tennis|teva|tf|tg|th|thd|theater|theatre|tiaa|tickets|tienda|tips|tires|tirol|tj|tjmaxx|tjx|tk|tkmaxx|tl|tm|tmall|tn|to|today|tokyo|tools|top|toray|toshiba|total|tours|town|toyota|toys|tr|trade|trading|training|travel|travelers|travelersinsurance|trust|trv|tt|tube|tui|tunes|tushu|tv|tvs|tw|tz|ua|ubank|ubs|ug|uk|unicom|university|uno|uol|ups|us|uy|uz|va|vacations|vana|vanguard|vc|ve|vegas|ventures|verisign|vermögensberater|vermögensberatung|versicherung|vet|vg|vi|viajes|video|vig|viking|villas|vin|vip|virgin|visa|vision|viva|vivo|vlaanderen|vn|vodka|volvo|vote|voting|voto|voyage|vu|wales|walmart|walter|wang|wanggou|watch|watches|weather|weatherchannel|webcam|weber|website|wed|wedding|weibo|weir|wf|whoswho|wien|wiki|williamhill|win|windows|wine|winners|wme|wolterskluwer|woodside|work|works|world|wow|ws|wtc|wtf|xbox|xerox|xihuan|xin|xxx|xyz|yachts|yahoo|yamaxun|yandex|ye|yodobashi|yoga|yokohama|you|youtube|yt|yun|za|zappos|zara|zero|zip|zm|zone|zuerich|zw|ελ|ευ|бг|бел|дети|ею|католик|ком|мкд|мон|москва|онлайн|орг|рус|рф|сайт|срб|укр|қаз|հայ|ישראל|קום|ابوظبي|ارامكو|الاردن|البحرين|الجزائر|السعودية|العليان|المغرب|امارات|ایران|بارت|بازار|بيتك|بھارت|تونس|سودان|سورية|شبكة|عراق|عرب|عمان|فلسطين|قطر|كاثوليك|كوم|مصر|مليسيا|موريتانيا|موقع|همراه|پاکستان|ڀارت|कॉम|नेट|भारत|भारतम्|भारोत|संगठन|বাংলা|ভারত|ভাৰত|ਭਾਰਤ|ભારત|ଭାରତ|இந்தியா|இலங்கை|சிங்கப்பூர்|భారత్|ಭಾರತ|ഭാരതം|ලංකා|คอม|ไทย|ລາວ|გე|みんな|アマゾン|クラウド|グーグル|コム|ストア|セール|ファッション|ポイント|世界|中信|中国|中國|中文网|亚马逊|企业|佛山|信息|健康|八卦|公司|公益|台湾|台灣|商城|商店|商标|嘉里|嘉里大酒店|在线|大拿|天主教|娱乐|家電|广东|微博|慈善|我爱你|手机|招聘|政务|政府|新加坡|新闻|时尚|書籍|机构|淡马锡|游戏|澳門|点看|移动|组织机构|网址|网店|网站|网络|联通|谷歌|购物|通販|集团|電訊盈科|飞利浦|食品|餐厅|香格里拉|香港|닷넷|닷컴|삼성|한국".split("|"));

  var POPULAR = [
    'gmail.com', 'googlemail.com', 'web.de', 'gmx.de', 'gmx.net', 'gmx.at', 'gmx.ch',
    't-online.de', 'outlook.de', 'outlook.com', 'hotmail.de', 'hotmail.com', 'live.de',
    'live.com', 'yahoo.de', 'yahoo.com', 'icloud.com', 'me.com', 'aol.com', 'aol.de',
    'freenet.de', 'arcor.de', 'online.de', 'mail.de', 'posteo.de', 'mailbox.org',
    'bluewin.ch', 'hispeed.ch', 'sunrise.ch', 'a1.net', 'chello.at', 'kabelmail.de',
    'vodafone.de', 'telekom.de', 'unitybox.de', 'ewetel.net', 'netcologne.de'
  ];

  var TLD_FIX = {
    con: 'com', cmo: 'com', ocm: 'com', comm: 'com', cim: 'com', xom: 'com', vom: 'com',
    dee: 'de', ded: 'de', d: 'de', ne: 'net', nte: 'net', cm: 'com'
  };

  var KEYBOARD_RUNS = [
    'qwertz', 'qwerty', 'asdfgh', 'yxcvbn', 'zxcvbn', 'qazwsx', 'asdasd', 'qweqwe',
    '123456', '654321', 'abcdef'
  ];

  var LOCAL_JUNK = [
    'test', 'testtest', 'asdf', 'asd', 'xxx', 'fake', 'nope', 'nomail',
    'keine', 'dummy', 'qwe', 'blabla', 'egal', 'garnix'
  ];

  var PROVIDER_TLDS = {
    gmail: ['com'],
    googlemail: ['com'],
    web: ['de'],
    't-online': ['de'],
    freenet: ['de'],
    arcor: ['de'],
    icloud: ['com'],
    posteo: ['de', 'net'],
    mailbox: ['org'],
    bluewin: ['ch'],
    hispeed: ['ch'],
    protonmail: ['com', 'ch'],
    gmx: ['de', 'net', 'at', 'ch', 'com', 'fr', 'us', 'li', 'co.uk', 'es', 'it']
  };

  var DOMAIN_JUNK = [
    'test', 'tests', 'testing', 'testmail', 'beispiel', 'example', 'fake', 'dummy',
    'asdf', 'abc', 'xxx', 'qwertz', 'qwerty', 'nomail', 'keine', 'egal', 'blabla',
    'none', 'nope', 'aaa', 'nix', 'kein', 'garnix', 'privat'
  ];

  var RESERVED_TLD = ['test', 'invalid', 'example', 'localhost', 'local', 'internal'];

  var disposableSet = null;
  var disposableLoading = null;
  var state = new WeakMap();
  var mxCache = {};

  function text(key, fallback) {
    return T[key] || fallback;
  }

  function fieldHint(field) {
    var parts = [
      field.name || '',
      field.id || '',
      field.placeholder || '',
      field.getAttribute('aria-label') || '',
      field.getAttribute('autocomplete') || '',
      field.getAttribute('data-testid') || ''
    ];
    var labels = field.labels;
    if (labels && labels.length) {
      for (var i = 0; i < labels.length; i++) parts.push(labels[i].textContent || '');
    } else {
      var described = field.getAttribute('aria-labelledby');
      var root = field.getRootNode ? field.getRootNode() : document;
      if (described && root.getElementById) {
        var lab = root.getElementById(described);
        if (lab) parts.push(lab.textContent || '');
      }
      var wrap = field.parentNode;
      for (var d = 0; d < 2 && wrap && wrap.nodeType === 1; d++) {
        var txt = wrap.textContent || '';
        if (txt.length < 80) parts.push(txt);
        wrap = wrap.parentNode;
      }
    }
    return parts.join(' ').toLowerCase();
  }

  function matchesAny(field, group) {
    var list = group.split(', ');
    for (var i = 0; i < list.length; i++) {
      try {
        if (field.matches(list[i])) return true;
      } catch (e) {}
    }
    return false;
  }

  var SKIP_DEFAULT = [
    'form[action*="/account/login"]',
    'form[action*="/account/register"]',
    'form[action*="/account/recover"]',
    'form[action*="/account/addresses"]',
    'form[action*="/checkout"]',
    'form[action*="/cart"]',
    'form[action*="/search"]',
    'form[action*="/localization"]'
  ].join(', ');

  function inSkippedForm(field) {
    var sel = typeof CFG.skipForms === 'string' ? CFG.skipForms : SKIP_DEFAULT;
    if (!sel) return false;
    var form = field.form || (field.closest ? field.closest('form') : null);
    if (!form) return false;
    return matchesAny(form, sel);
  }

  function typeOf(field) {
    if (!field || field.tagName !== 'INPUT') return null;
    if (inSkippedForm(field)) return null;
    var t = (field.getAttribute('type') || 'text').toLowerCase();
    if (t === 'hidden' || t === 'checkbox' || t === 'radio' || t === 'file' || t === 'password') return null;
    if (matchesAny(field, SEL_EMAIL)) return 'email';
    if (matchesAny(field, SEL_ZIP)) return 'zip';
    if (matchesAny(field, SEL_PHONE)) return 'phone';
    if (matchesAny(field, SEL_NAME)) return 'name';
    if (CFG.detectByLabel === false) return null;
    if (t !== 'text' && t !== 'search') return null;
    var hint = fieldHint(field);
    if (/e-?mail|mailadresse/.test(hint)) return 'email';
    if (/telefon|phone|mobil|handy/.test(hint)) return 'phone';
    if (/postleitzahl|\bplz\b|postal|zip.?code/.test(hint)) return 'zip';
    return null;
  }

  function loadDisposable() {
    if (disposableSet) return Promise.resolve(disposableSet);
    if (disposableLoading) return disposableLoading;
    if (!CFG.blocklistUrl) return Promise.resolve(null);
    disposableLoading = new Promise(function (resolve) {
      var s = document.createElement('script');
      s.src = CFG.blocklistUrl;
      s.async = true;
      s.onload = function () {
        var raw = window.CDX_DISPOSABLE_DOMAINS || '';
        disposableSet = new Set(raw.split('|'));
        resolve(disposableSet);
      };
      s.onerror = function () {
        resolve(null);
      };
      document.head.appendChild(s);
    });
    return disposableLoading;
  }

  function distance(a, b) {
    if (Math.abs(a.length - b.length) > 2) return 99;
    var prev = [];
    var i, j;
    for (j = 0; j <= b.length; j++) prev[j] = j;
    for (i = 1; i <= a.length; i++) {
      var cur = [i];
      for (j = 1; j <= b.length; j++) {
        cur[j] = Math.min(
          prev[j] + 1,
          cur[j - 1] + 1,
          prev[j - 1] + (a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1)
        );
      }
      prev = cur;
    }
    return prev[b.length];
  }

  function popularWithSld(sld) {
    for (var i = 0; i < POPULAR.length; i++) {
      if (POPULAR[i].split('.')[0] === sld) return POPULAR[i];
    }
    return null;
  }

  function suggestDomain(domain) {
    if (POPULAR.indexOf(domain) !== -1) return null;
    if (popularWithSld(domain.split('.')[0])) return null;
    var parts = domain.split('.');
    if (parts.length > 1) {
      var tld = parts[parts.length - 1];
      if (TLD_FIX[tld]) {
        var fixed = parts.slice(0, -1).join('.') + '.' + TLD_FIX[tld];
        if (POPULAR.indexOf(fixed) !== -1) return fixed;
      }
    }
    var best = null;
    var bestScore = 3;
    for (var i = 0; i < POPULAR.length; i++) {
      var d = distance(domain, POPULAR[i]);
      if (d > 0 && d < bestScore) {
        bestScore = d;
        best = POPULAR[i];
      }
    }
    if (best && domain.length > 5) return best;
    return null;
  }

  function providerMismatch(domain) {
    var parts = domain.split('.');
    if (parts.length < 2) return null;
    var sld = parts[0];
    var rest = parts.slice(1).join('.');
    var allowed = PROVIDER_TLDS[sld];
    if (!allowed) return null;
    if (allowed.indexOf(rest) !== -1) return null;
    return sld + '.' + allowed[0];
  }

  function hasRun(value, runs) {
    for (var i = 0; i < runs.length; i++) {
      if (value.indexOf(runs[i]) !== -1) return true;
    }
    return false;
  }

  function repeatedChars(value, min) {
    var run = 1;
    for (var i = 1; i < value.length; i++) {
      if (value.charAt(i) === value.charAt(i - 1)) {
        run++;
        if (run >= min) return true;
      } else {
        run = 1;
      }
    }
    return false;
  }

  function sequential(digits, min) {
    var up = 1;
    var down = 1;
    for (var i = 1; i < digits.length; i++) {
      var delta = digits.charCodeAt(i) - digits.charCodeAt(i - 1);
      up = delta === 1 ? up + 1 : 1;
      down = delta === -1 ? down + 1 : 1;
      if (up >= min || down >= min) return true;
    }
    return false;
  }

  function validEmailSyntax(value) {
    if (/[\s,;:<>()\[\]\\"]/.test(value)) return false;
    var at = value.lastIndexOf('@');
    if (at < 1 || at === value.length - 1) return false;
    var local = value.slice(0, at);
    var domain = value.slice(at + 1);
    if (local.length > 64 || value.length > 254) return false;
    if (local.charAt(0) === '.' || local.charAt(local.length - 1) === '.') return false;
    if (local.indexOf('..') !== -1) return false;
    if (domain.indexOf('.') === -1) return false;
    var labels = domain.split('.');
    for (var i = 0; i < labels.length; i++) {
      var l = labels[i];
      if (!l.length || l.length > 63) return false;
      if (l.charAt(0) === '-' || l.charAt(l.length - 1) === '-') return false;
      if (/[^0-9A-Za-z\u00C0-\uFFFF-]/.test(l)) return false;
    }
    var tld = labels[labels.length - 1];
    if (tld.length < 2 || /[0-9-]/.test(tld)) return false;
    return true;
  }

  function unknownTld(domain) {
    if (CFG.checkTld === false) return false;
    var labels = domain.split('.');
    var tld = labels[labels.length - 1].toLowerCase();
    if (tld.indexOf('xn--') === 0) return false;
    if (/[^a-z]/.test(tld)) return false;
    return !TLD_SET.has(tld);
  }

  function normalizeAddress(raw) {
    var v = (raw || '').trim().replace(/\s+/g, '');
    var angled = v.match(/<([^>]+)>/);
    if (angled) v = angled[1].trim();
    v = v.replace(/^mailto:/i, '');
    v = v.replace(/^[,;]+/, '').replace(/[,;.]+$/, '');
    return v;
  }

  function junkLocalPart(local) {
    var l = local.toLowerCase();
    var stripped = l.replace(/[._+-]/g, '');
    if (!stripped) return true;
    if (/^\d+$/.test(stripped) && stripped.length >= 4) return true;
    if (LOCAL_JUNK.indexOf(stripped) !== -1) return true;
    if (hasRun(stripped, KEYBOARD_RUNS)) return true;
    if (repeatedChars(stripped, 4)) return true;
    if (stripped.length >= 6 && sequential(stripped, 5)) return true;
    if (stripped.length >= 12 && !/[aeiouäöüy]/.test(stripped)) return true;
    return false;
  }

  function junkDomain(domain) {
    var parts = domain.split('.');
    if (parts.length < 2) return true;
    var tld = parts[parts.length - 1];
    if (RESERVED_TLD.indexOf(tld) !== -1) return true;
    var extra = CFG.blockedDomains || [];
    if (extra.indexOf(domain) !== -1) return true;
    for (var i = 0; i < parts.length - 1; i++) {
      var label = parts[i];
      if (DOMAIN_JUNK.indexOf(label) !== -1) return true;
      if (/^\d+$/.test(label)) return true;
      if (hasRun(label, KEYBOARD_RUNS)) return true;
      if (repeatedChars(label, 4)) return true;
    }
    return false;
  }

  function dohQuery(url, headers) {
    var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timer = setTimeout(function () {
      if (ctrl) ctrl.abort();
    }, CFG.dnsTimeout || 2500);
    return fetch(url, { headers: headers, signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) {
        clearTimeout(timer);
        if (!r.ok) throw new Error('dns');
        return r.json();
      });
  }

  function hasMailExchange(domain) {
    if (CFG.checkMx === false) return Promise.resolve(true);
    if (Object.prototype.hasOwnProperty.call(mxCache, domain)) {
      return Promise.resolve(mxCache[domain]);
    }
    try {
      var stored = sessionStorage.getItem('cdxmx:' + domain);
      if (stored !== null) {
        mxCache[domain] = stored === '1';
        return Promise.resolve(mxCache[domain]);
      }
    } catch (e) {}

    var evaluate = function (data) {
      if (!data || typeof data.Status === 'undefined') return true;
      if (data.Status === 3) return false;
      if (data.Status !== 0) return true;
      var answers = data.Answer || [];
      for (var i = 0; i < answers.length; i++) {
        if (answers[i].type === 15) return true;
      }
      return false;
    };

    return dohQuery(
      'https://cloudflare-dns.com/dns-query?name=' + encodeURIComponent(domain) + '&type=MX',
      { accept: 'application/dns-json' }
    )
      .catch(function () {
        return dohQuery(
          'https://dns.google/resolve?name=' + encodeURIComponent(domain) + '&type=MX',
          { accept: 'application/json' }
        );
      })
      .then(function (data) {
        var ok = evaluate(data);
        if (ok) return true;
        if (CFG.strictMx === true) return false;
        return dohQuery(
          'https://cloudflare-dns.com/dns-query?name=' + encodeURIComponent(domain) + '&type=A',
          { accept: 'application/dns-json' }
        ).then(function (a) {
          return !!(a && a.Answer && a.Answer.length);
        }).catch(function () {
          return false;
        });
      })
      .then(function (ok) {
        mxCache[domain] = ok;
        try {
          sessionStorage.setItem('cdxmx:' + domain, ok ? '1' : '0');
        } catch (e) {}
        return ok;
      })
      .catch(function () {
        debugLog('MX-Abfrage fehlgeschlagen, Adresse wird durchgelassen:', domain);
        return true;
      });
  }

  function isFlowLayout(node) {
    if (!node || node.nodeType !== 1) return false;
    var d = '';
    try {
      d = window.getComputedStyle(node).display;
    } catch (e) {
      return true;
    }
    return d !== 'flex' && d !== 'inline-flex' && d !== 'grid' && d !== 'inline-grid';
  }

  function hasAbsoluteChild(node) {
    var kids = node.children || [];
    for (var i = 0; i < kids.length; i++) {
      var pos = '';
      try {
        pos = window.getComputedStyle(kids[i]).position;
      } catch (e) {}
      if (pos === 'absolute' || pos === 'fixed') return true;
    }
    return false;
  }

  function anchorFor(field) {
    var node = field;
    var parent = field.parentNode;
    var depth = 0;
    var limit = typeof CFG.anchorDepth === 'number' ? CFG.anchorDepth : 1;
    while (parent && parent.nodeType === 1 && depth <= limit) {
      if (parent.tagName === 'FORM') break;
      if (isFlowLayout(parent) && !hasAbsoluteChild(parent)) {
        return { parent: parent, before: node.nextSibling };
      }
      node = parent;
      parent = parent.parentNode;
      depth++;
    }
    if (node !== field && node.parentNode) {
      return { parent: node.parentNode, before: node.nextSibling };
    }
    return { parent: field.parentNode, before: field.nextSibling };
  }

  function effectiveBackground(node) {
    var hop = 0;
    while (node && node.nodeType === 1 && hop < 8) {
      var bg = '';
      try {
        bg = window.getComputedStyle(node).backgroundColor;
      } catch (e) {}
      if (bg && bg !== 'transparent' && bg.replace(/\s/g, '') !== 'rgba(0,0,0,0)') return bg;
      node = node.parentNode;
      hop++;
    }
    return 'rgb(255, 255, 255)';
  }

  function luminance(color) {
    var m = color.match(/(\d+)[,\s]+(\d+)[,\s]+(\d+)/);
    if (!m) return 1;
    return (0.2126 * m[1] + 0.7152 * m[2] + 0.0722 * m[3]) / 255;
  }

  function messageBody(el) {
    var body = el.querySelector('.cdx-mv-text');
    if (!body) {
      body = document.createElement('span');
      body.className = 'cdx-mv-text';
      el.appendChild(body);
    }
    return body;
  }

  function applyContrast(body, color) {
    var mode = CFG.messagePlate;
    body.style.removeProperty('background-color');
    body.style.removeProperty('padding');
    body.style.removeProperty('border-radius');
    body.style.setProperty('color', color, 'important');
    if (mode === false) return;
    if (luminance(effectiveBackground(body.parentNode)) >= 0.62) return;
    if (mode === 'invert') {
      body.style.setProperty('color', CFG.invertColor || '#ffffff', 'important');
      return;
    }
    if (mode === 'light') {
      body.style.setProperty('background-color', CFG.plateColor || '#ffffff', 'important');
    } else {
      body.style.setProperty('background-color', color, 'important');
      body.style.setProperty('color', CFG.plateTextColor || '#ffffff', 'important');
    }
    body.style.setProperty('padding', '0.35em 0.7em', 'important');
    body.style.setProperty('border-radius', CFG.plateRadius || '4px', 'important');
  }

  function freezeFloatingButtons(field) {
    if (CFG.freezeButtons === false) return;
    var form = field.form || (field.closest ? field.closest('form') : null);
    var scope = form || field.parentNode;
    if (!scope || !scope.querySelectorAll) return;
    var btns = scope.querySelectorAll('button, [type="submit"], [type="button"]');
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      if (btn.getAttribute('data-cdx-mv-frozen')) continue;
      var pos = '';
      var h = '';
      try {
        var cs = window.getComputedStyle(btn);
        pos = cs.position;
        h = cs.height;
      } catch (e) {}
      if (pos !== 'absolute' && pos !== 'fixed') continue;
      var px = btn.offsetHeight;
      if (!px) continue;
      btn.setAttribute('data-cdx-mv-frozen', h || '');
      btn.style.setProperty('height', px + 'px', 'important');
    }
  }

  function unfreezeFloatingButtons(field) {
    var form = field.form || (field.closest ? field.closest('form') : null);
    var scope = form || field.parentNode;
    if (!scope || !scope.querySelectorAll) return;
    var btns = scope.querySelectorAll('[data-cdx-mv-frozen]');
    for (var i = 0; i < btns.length; i++) {
      btns[i].style.removeProperty('height');
      btns[i].removeAttribute('data-cdx-mv-frozen');
    }
  }

  function formHasVisibleMessage(field) {
    var form = field.form || (field.closest ? field.closest('form') : null);
    var scope = form || field.parentNode;
    if (!scope || !scope.querySelectorAll) return false;
    var msgs = scope.querySelectorAll('.cdx-mv-message, .cdx-mv-form-message');
    for (var i = 0; i < msgs.length; i++) {
      if (msgs[i].textContent) return true;
    }
    return false;
  }

  function messageEl(field) {
    var st = state.get(field);
    if (st && st.msg && st.msg.parentNode) {
      freezeFloatingButtons(field);
      return st.msg;
    }
    freezeFloatingButtons(field);
    var el = document.createElement('div');
    el.className = 'cdx-mv-message';
    el.setAttribute('aria-live', 'polite');
    var spot = anchorFor(field);
    if (spot.parent) spot.parent.insertBefore(el, spot.before);
    if (st) st.msg = el;
    return el;
  }

  function markField(field, mode) {
    if (!mode) {
      field.classList.remove('cdx-mv-invalid');
      field.classList.remove('cdx-mv-warn');
      field.removeAttribute('data-cdx-mv');
      field.style.removeProperty('border-color');
      field.style.removeProperty('box-shadow');
      return;
    }
    var color = mode === 'error'
      ? (CFG.errorColor || '#e02229')
      : (CFG.warnColor || '#d19a00');
    field.classList.remove(mode === 'error' ? 'cdx-mv-warn' : 'cdx-mv-invalid');
    field.classList.add(mode === 'error' ? 'cdx-mv-invalid' : 'cdx-mv-warn');
    field.setAttribute('data-cdx-mv', mode);
    field.style.setProperty('border-color', color, 'important');
    if (CFG.fieldGlow !== false) {
      field.style.setProperty('box-shadow', 'inset 0 0 0 1px ' + color, 'important');
    }
  }

  function clearMessage(field) {
    var st = state.get(field);
    if (st && st.msg) {
      st.msg.textContent = '';
      st.msg.className = 'cdx-mv-message';
    }
    markField(field, null);
    field.removeAttribute('aria-invalid');
    if (!formHasVisibleMessage(field)) unfreezeFloatingButtons(field);
  }

  function showError(field, msg) {
    var el = messageEl(field);
    el.className = 'cdx-mv-message cdx-mv-message--error';
    var body = messageBody(el);
    body.textContent = msg;
    applyContrast(body, CFG.errorColor || '#e02229');
    markField(field, 'error');
    field.setAttribute('aria-invalid', 'true');
  }

  function showWarning(field, msg) {
    var el = messageEl(field);
    el.className = 'cdx-mv-message cdx-mv-message--warn';
    var body = messageBody(el);
    body.textContent = msg;
    applyContrast(body, CFG.warnColor || '#d19a00');
    markField(field, 'warn');
  }

  function showSuggestion(field, corrected, hard) {
    var el = messageEl(field);
    el.className = 'cdx-mv-message cdx-mv-message--' + (hard ? 'error' : 'hint');
    el.textContent = '';
    var body = messageBody(el);
    applyContrast(body, hard ? (CFG.errorColor || '#e02229') : (CFG.hintColor || '#5c5c5c'));
    if (hard) {
      markField(field, 'error');
      field.setAttribute('aria-invalid', 'true');
    }
    var span = document.createElement('span');
    span.textContent = text('suggest', 'Meintest du') + ' ';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'cdx-mv-suggest';
    btn.textContent = corrected;
    var reset = {
      appearance: 'none', background: 'none', 'background-color': 'transparent',
      border: '0', 'border-radius': '0', 'box-shadow': 'none', color: 'inherit',
      cursor: 'pointer', display: 'inline', font: 'inherit', 'font-size': 'inherit',
      'font-weight': 'inherit', height: 'auto', 'letter-spacing': 'inherit',
      'line-height': 'inherit', margin: '0', 'min-height': '0', 'min-width': '0',
      padding: '0', 'text-decoration': 'underline', 'text-transform': 'none',
      width: 'auto'
    };
    for (var prop in reset) {
      btn.style.setProperty(prop, reset[prop], 'important');
    }
    btn.addEventListener('click', function () {
      field.value = corrected;
      clearMessage(field);
      validate(field, false);
      field.focus();
    });
    body.appendChild(span);
    body.appendChild(btn);
    body.appendChild(document.createTextNode('?'));
  }

  function formMessage(form, msg) {
    var el = form.querySelector('.cdx-mv-form-message');
    if (!el) {
      if (!msg) return;
      el = document.createElement('div');
      el.className = 'cdx-mv-form-message';
      el.setAttribute('role', 'alert');
      el.style.setProperty('color', CFG.errorColor || '#e02229', 'important');
      el.style.setProperty('border-color', CFG.errorColor || '#e02229', 'important');
      form.appendChild(el);
    }
    el.textContent = msg || '';
  }

  function setBusy(form, busy) {
    var btn = form.querySelector('[type="submit"]');
    if (!btn) return;
    if (busy) {
      btn.disabled = true;
      btn.classList.add('cdx-mv-checking');
    } else {
      btn.disabled = false;
      btn.classList.remove('cdx-mv-checking');
    }
  }

  function fakeNumber(digits) {
    var core = digits.replace(/^(?:00|\+)?49/, '').replace(/^0+/, '');
    if (!core) return true;
    if (repeatedChars(digits, 6)) return true;
    var seen = {};
    var distinct = 0;
    for (var i = 0; i < core.length; i++) {
      if (!seen[core.charAt(i)]) {
        seen[core.charAt(i)] = 1;
        distinct++;
      }
    }
    if (core.length >= 6 && distinct <= 2) return true;
    if (core.length >= 5 && sequential(core, core.length)) return true;
    return false;
  }

  function validatePhone(field) {
    var raw = (field.value || '').trim();
    if (!raw) return { ok: true, hard: false };
    if (/^\+?\d{1,4}$/.test(raw.replace(/[\s()\/.-]/g, ''))) {
      return { ok: true, hard: false };
    }
    if (/[A-Za-zÀ-ÿ]/.test(raw)) {
      return { ok: false, hard: false, msg: text('phone', 'Bitte gib eine gültige Telefonnummer an.') };
    }
    var digits = raw.replace(/\D/g, '');
    if (digits.length < 6 || digits.length > 15) {
      return { ok: false, hard: false, msg: text('phone', 'Bitte gib eine gültige Telefonnummer an.') };
    }
    if (fakeNumber(digits)) {
      return { ok: false, hard: false, msg: text('phoneFake', 'Diese Telefonnummer sieht nicht echt aus. Bitte prüfe deine Eingabe.') };
    }
    return { ok: true, hard: false };
  }

  function validateZip(field) {
    var raw = (field.value || '').trim();
    if (!raw) return { ok: true, hard: false };
    var digits = raw.replace(/\s/g, '');
    if (!/^\d{4,5}$/.test(digits)) {
      return { ok: false, hard: false, msg: text('zip', 'Bitte gib eine gültige Postleitzahl an.') };
    }
    if (/^0+$/.test(digits) || repeatedChars(digits, 4) || sequential(digits, 4)) {
      return { ok: false, hard: false, msg: text('zipFake', 'Diese Postleitzahl sieht nicht echt aus. Bitte prüfe deine Eingabe.') };
    }
    return { ok: true, hard: false };
  }

  function validateName(field) {
    var raw = (field.value || '').trim();
    if (!raw) return { ok: true, hard: false };
    if (/\d/.test(raw) || /https?:|www\.|@/.test(raw)) {
      return { ok: false, hard: false, msg: text('name', 'Bitte gib deinen Namen ohne Zahlen oder Links an.') };
    }
    if (raw.replace(/[^A-Za-zÀ-ÿ]/g, '').length < 2) {
      return { ok: false, hard: false, msg: text('name', 'Bitte gib deinen Namen ohne Zahlen oder Links an.') };
    }
    if (repeatedChars(raw.toLowerCase(), 4) || hasRun(raw.toLowerCase(), KEYBOARD_RUNS)) {
      return { ok: false, hard: false, msg: text('nameFake', 'Dieser Name sieht nicht echt aus. Bitte prüfe deine Eingabe.') };
    }
    return { ok: true, hard: false };
  }

  function applyResult(field, res, st) {
    st.settled = true;
    st.ok = res.ok;
    st.hard = res.ok ? false : res.hard;
    if (res.ok) {
      clearMessage(field);
    } else if (res.hard) {
      showError(field, res.msg);
    } else {
      showWarning(field, res.msg);
    }
    return res;
  }

  function validate(field, hard) {
    var st = state.get(field);
    if (!st) {
      st = {};
      state.set(field, st);
    }
    st.settled = false;

    if (field.tagName === 'TEXTAREA') {
      st.checkedValue = (field.value || '').trim();
      return Promise.resolve(applyResult(field, validateMessage(field), st));
    }

    var kind = typeOf(field);

    if (kind !== 'email') {
      st.checkedValue = (field.value || '').trim();
      var enabled = kind === 'phone' ? CFG.checkPhone : kind === 'zip' ? CFG.checkZip : CFG.checkName;
      if (enabled === false) {
        clearMessage(field);
        st.settled = true;
        st.ok = true;
        st.hard = false;
        return Promise.resolve({ ok: true, hard: false });
      }
      var fn = kind === 'phone' ? validatePhone : kind === 'zip' ? validateZip : validateName;
      return Promise.resolve(applyResult(field, fn(field), st));
    }

    var value = normalizeAddress(field.value);
    st.checkedValue = value;
    if (field.value !== value) field.value = value;

    if (!value) {
      clearMessage(field);
      st.settled = true;
      st.ok = !field.required;
      st.hard = !!field.required;
      return Promise.resolve({ ok: st.ok, hard: st.hard });
    }

    if (!validEmailSyntax(value)) {
      return Promise.resolve(applyResult(field, {
        ok: false, hard: true, msg: text('syntax', 'Diese E-Mail-Adresse ist nicht gültig.')
      }, st));
    }

    var local = value.split('@')[0];
    var domain = value.split('@').pop().toLowerCase();

    if (unknownTld(domain)) {
      var fixedTld = popularWithSld(domain.split('.')[0]) || suggestDomain(domain);
      if (fixedTld) {
        showSuggestion(field, local + '@' + fixedTld, true);
        st.settled = true;
        st.ok = false;
        st.hard = true;
        return Promise.resolve({ ok: false, hard: true, reason: 'tld' });
      }
      return Promise.resolve(applyResult(field, {
        ok: false, hard: true, msg: text('tld', 'Diese Domain-Endung gibt es nicht. Bitte prüfe die Schreibweise.')
      }, st));
    }

    var wrongProvider = providerMismatch(domain);
    if (wrongProvider) {
      showSuggestion(field, local + '@' + wrongProvider, true);
      st.settled = true;
      st.ok = false;
      st.hard = true;
      return Promise.resolve({ ok: false, hard: true, reason: 'provider' });
    }

    if (junkLocalPart(local) || junkDomain(domain)) {
      return Promise.resolve(applyResult(field, {
        ok: false, hard: true, msg: text('localJunk', 'Bitte gib deine echte E-Mail-Adresse an.')
      }, st));
    }

    var corrected = suggestDomain(domain);
    if (corrected) {
      var blockTypo = CFG.blockTypos !== false;
      showSuggestion(field, local + '@' + corrected, blockTypo);
      st.settled = true;
      st.ok = !blockTypo;
      st.hard = blockTypo;
      return Promise.resolve({ ok: !blockTypo, hard: blockTypo, reason: 'typo' });
    }

    return loadDisposable().then(function (set) {
      if (set && set.has(domain)) {
        return applyResult(field, {
          ok: false, hard: true,
          msg: text('disposable', 'Wegwerf-Adressen sind nicht zulässig. Bitte gib eine dauerhaft erreichbare E-Mail-Adresse an.')
        }, st);
      }
      return hasMailExchange(domain).then(function (ok) {
        if (!ok) {
          return applyResult(field, {
            ok: false, hard: true,
            msg: text('nomx', 'Unter dieser Domain können keine E-Mails empfangen werden. Bitte prüfe die Schreibweise.')
          }, st);
        }
        clearMessage(field);
        st.settled = true;
        st.ok = true;
        st.hard = false;
        return { ok: true, hard: false };
      });
    });
  }

  function rateEntries() {
    try {
      var raw = localStorage.getItem('cdxrl');
      if (!raw) return [];
      var arr = JSON.parse(raw);
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      return [];
    }
  }

  function rateRecent() {
    var win = (CFG.rateWindowMinutes || 60) * 60000;
    var now = Date.now();
    return rateEntries().filter(function (t) {
      return typeof t === 'number' && now - t < win;
    });
  }

  function testMode() {
    try {
      if (window.location.search.indexOf('cdx-mv-test=1') !== -1) {
        sessionStorage.setItem('cdxmv-test', '1');
        return true;
      }
      if (window.location.search.indexOf('cdx-mv-test=0') !== -1) {
        sessionStorage.removeItem('cdxmv-test');
        return false;
      }
      return sessionStorage.getItem('cdxmv-test') === '1';
    } catch (e) {
      return false;
    }
  }

  function rateExceeded() {
    var max = CFG.maxSubmits || 0;
    if (!max) return false;
    if (testMode()) return false;
    return rateRecent().length >= max;
  }

  function rateRecord() {
    if (!CFG.maxSubmits) return;
    var recent = rateRecent();
    recent.push(Date.now());
    try {
      localStorage.setItem('cdxrl', JSON.stringify(recent));
    } catch (e) {}
  }

  function formState(form) {
    if (!form.__cdxMv) {
      form.__cdxMv = { keys: 0, pastes: 0, pointers: 0, started: Date.now(), fields: {} };
    }
    return form.__cdxMv;
  }

  function isAutomated() {
    try {
      if (navigator.webdriver === true) return true;
      if (window.callPhantom || window._phantom || window.__nightmare) return true;
      if (/HeadlessChrome|PhantomJS|Electron\/.*Puppeteer/i.test(navigator.userAgent)) return true;
    } catch (e) {}
    return false;
  }

  function mixedScripts(value) {
    var latin = /[A-Za-z]/.test(value);
    var cyrillic = /[\u0400-\u04FF]/.test(value);
    var greek = /[\u0370-\u03FF]/.test(value);
    var cjk = /[\u3040-\u30FF\u4E00-\u9FFF\uAC00-\uD7AF]/.test(value);
    var arabic = /[\u0600-\u06FF]/.test(value);
    var count = (cyrillic ? 1 : 0) + (greek ? 1 : 0) + (cjk ? 1 : 0) + (arabic ? 1 : 0);
    if (!count) return false;
    return latin || count > 1;
  }

  function countLinks(value) {
    var m = value.match(/(https?:\/\/|www\.|\[url|\[link|<a\s)/gi);
    return m ? m.length : 0;
  }

  function validateMessage(field) {
    if (CFG.checkMessage === false) return { ok: true, hard: false };
    var raw = (field.value || '').trim();
    if (!raw) return { ok: true, hard: false };
    if (countLinks(raw) >= (CFG.maxLinks || 2)) {
      return { ok: false, hard: true, msg: text('links', 'Bitte sende deine Anfrage ohne Links.') };
    }
    if (mixedScripts(raw)) {
      return { ok: false, hard: true, msg: text('script', 'Bitte formuliere deine Anfrage in lateinischer Schrift.') };
    }
    if (raw.length > (CFG.maxMessageLength || 5000)) {
      return { ok: false, hard: true, msg: text('long', 'Deine Nachricht ist zu lang. Bitte fasse dich kürzer.') };
    }
    return { ok: true, hard: false };
  }

  function fingerprint(form) {
    var parts = [];
    var els = form.querySelectorAll('input, textarea, select');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (!el.name || el.type === 'hidden' || el.type === 'submit') continue;
      parts.push(el.name + '=' + (el.value || ''));
    }
    var str = parts.join('&');
    var hash = 5381;
    for (var c = 0; c < str.length; c++) {
      hash = ((hash << 5) + hash + str.charCodeAt(c)) | 0;
    }
    return String(hash);
  }

  function duplicateSubmit(form) {
    if (CFG.blockDuplicates === false) return false;
    var fp = fingerprint(form);
    try {
      var raw = localStorage.getItem('cdxfp');
      var seen = raw ? JSON.parse(raw) : {};
      var now = Date.now();
      var win = (CFG.duplicateWindowHours || 24) * 3600000;
      for (var k in seen) {
        if (now - seen[k] > win) delete seen[k];
      }
      if (seen[fp]) return true;
      form.__cdxMvFp = fp;
      localStorage.setItem('cdxfp', JSON.stringify(seen));
    } catch (e) {}
    return false;
  }

  function rememberSubmit(form) {
    if (CFG.blockDuplicates === false || !form.__cdxMvFp) return;
    try {
      var raw = localStorage.getItem('cdxfp');
      var seen = raw ? JSON.parse(raw) : {};
      seen[form.__cdxMvFp] = Date.now();
      localStorage.setItem('cdxfp', JSON.stringify(seen));
    } catch (e) {}
  }

  function noHumanInput(form) {
    var st = formState(form);
    if (st.keys > 0 || st.pastes > 0) return false;
    var filled = 0;
    var els = form.querySelectorAll('input, textarea');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.type === 'hidden' || el.type === 'submit' || el.type === 'checkbox') continue;
      if ((el.value || '').trim()) filled++;
    }
    return filled >= 2;
  }

  function armHoneypot(form) {
    if (form.dataset.cdxMvHp) return;
    form.dataset.cdxMvHp = String(Date.now());
    var st = formState(form);
    var mark = function () {
      form.dataset.cdxMvHuman = '1';
    };
    form.addEventListener('keydown', function () {
      st.keys++;
      mark();
    });
    form.addEventListener('paste', function () {
      st.pastes++;
      mark();
    });
    form.addEventListener('pointerdown', function () {
      st.pointers++;
      mark();
    });
    if (CFG.honeypot === false) return;
    if (!/\/contact/.test(form.getAttribute('action') || '')) return;
    var wrap = document.createElement('div');
    wrap.className = 'cdx-mv-hp';
    wrap.setAttribute('aria-hidden', 'true');
    var input = document.createElement('input');
    input.type = 'text';
    input.name = 'cdx_website_url';
    input.tabIndex = -1;
    input.autocomplete = 'off';
    wrap.appendChild(input);
    form.appendChild(wrap);
  }

  function honeypotTripped(form) {
    if (CFG.honeypot === false || testMode()) return false;
    var hp = form.querySelector('.cdx-mv-hp input');
    if (hp && hp.value) return true;
    if (form.dataset.cdxMvHuman === '1') return false;
    var started = parseInt(form.dataset.cdxMvHp || '0', 10);
    var min = (CFG.minSeconds || 0) * 1000;
    if (started && min && Date.now() - started < min) return true;
    return false;
  }

  function attach(field) {
    if (state.has(field)) return;
    var kind = typeOf(field);
    if (!kind) {
      debugLog('ignoriert', field.id || field.name || field.getAttribute('data-testid') || '(ohne id)', field);
      return;
    }
    debugLog('erkannt als ' + kind, field.id || field.name || field.getAttribute('data-testid') || '(ohne id)', field);
    state.set(field, {});
    if (kind === 'email') {
      field.addEventListener('focus', loadDisposable, { once: true });
    }
    field.addEventListener('blur', function () {
      validate(field, false);
    });
    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(function () {
        var st = state.get(field);
        if (!st || !st.settled || st.ok) return;
        if (!st.msg || !st.msg.textContent) return;
        var mode = st.hard ? 'error' : 'warn';
        if (field.getAttribute('data-cdx-mv') !== mode) markField(field, mode);
      }).observe(field, { attributes: true, attributeFilter: ['class', 'style'] });
    }
    field.addEventListener('input', function () {
      var st = state.get(field);
      if (!st) return;
      if (st.settled && st.checkedValue !== (field.value || '').trim()) {
        st.settled = false;
        clearMessage(field);
      }
      if (kind !== 'email') return;
      clearTimeout(st.timer);
      st.timer = setTimeout(function () {
        var v = (field.value || '').trim();
        if (v && validEmailSyntax(normalizeAddress(v))) validate(field, false);
      }, CFG.liveDelay || 900);
    });
  }

  var roots = [];

  function injectStyles(shadow) {
    if (shadow.querySelector('style[data-cdx-mv]')) return;
    var source = document.getElementById('cdx-mv-styles');
    if (!source) return;
    var clone = document.createElement('style');
    clone.setAttribute('data-cdx-mv', '1');
    clone.textContent = source.textContent;
    shadow.insertBefore(clone, shadow.firstChild);
  }

  function registerRoot(root) {
    if (roots.indexOf(root) !== -1) return;
    roots.push(root);
    if (root !== document) {
      root.addEventListener('submit', onSubmit, true);
      injectStyles(root);
    }
    observeRoot(root);
  }

  function observeRoot(root) {
    if (typeof MutationObserver === 'undefined') return;
    var target = root === document ? document.documentElement : root;
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1) scan(added[j]);
        }
      }
    }).observe(target, { childList: true, subtree: true });
  }

  function debugLog() {
    if (!(CFG.debug || testMode()) || !window.console) return;
    var args = ['[cdx-mv]'].concat(Array.prototype.slice.call(arguments));
    console.log.apply(console, args);
  }

  function scan(root) {
    var scope = root || document;
    var nodes = scope.querySelectorAll('input');
    for (var i = 0; i < nodes.length; i++) attach(nodes[i]);

    if (scope.querySelectorAll) {
      var forms = scope.querySelectorAll('form');
      for (var f = 0; f < forms.length; f++) {
        var frm = forms[f];
        if (matchesAny(frm, typeof CFG.skipForms === 'string' ? CFG.skipForms : SKIP_DEFAULT)) continue;
        if (!frm.querySelector('input')) continue;
        armHoneypot(frm);
      }
    }

    if (CFG.pierceShadow === false) return;
    var all = scope.querySelectorAll('*');
    for (var k = 0; k < all.length; k++) {
      var sr = all[k].shadowRoot;
      if (sr) {
        registerRoot(sr);
        scan(sr);
      }
    }
    if (scope.shadowRoot) {
      registerRoot(scope.shadowRoot);
      scan(scope.shadowRoot);
    }
  }

  function resubmit(form) {
    form.dataset.cdxMvPassed = '1';
    rateRecord();
    rememberSubmit(form);
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.submit();
    }
  }

  function onSubmit(e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    if (form.dataset.cdxMvPassed === '1') {
      delete form.dataset.cdxMvPassed;
      return;
    }
    var candidates = form.querySelectorAll('input');
    var fields = [];
    for (var c = 0; c < candidates.length; c++) {
      if (state.has(candidates[c]) && typeOf(candidates[c])) fields.push(candidates[c]);
    }
    var areas = form.querySelectorAll('textarea');
    for (var a = 0; a < areas.length; a++) fields.push(areas[a]);
    if (!fields.length) return;

    if (honeypotTripped(form)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      debugLog('blockiert: Honeypot oder Zeitfalle');
      return;
    }

    if (CFG.blockAutomation !== false && isAutomated() && !testMode()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      debugLog('blockiert: Automatisierung erkannt');
      return;
    }

    if (CFG.requireInput !== false && noHumanInput(form) && !testMode()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      debugLog('blockiert: keine Tastatureingabe registriert');
      return;
    }

    e.preventDefault();
    e.stopImmediatePropagation();
    setBusy(form, true);

    var checks = [];
    for (var i = 0; i < fields.length; i++) {
      checks.push(validate(fields[i], true));
    }

    Promise.all(checks).then(function (results) {
      setBusy(form, false);
      var blocker = -1;
      for (var i = 0; i < results.length; i++) {
        if (!results[i].ok && results[i].hard) {
          blocker = i;
          break;
        }
      }
      if (blocker !== -1) {
        formMessage(form, '');
        fields[blocker].focus();
        return;
      }
      if (rateExceeded()) {
        formMessage(form, text('rate', 'Du hast in kurzer Zeit mehrere Anfragen gesendet. Bitte versuche es später noch einmal oder ruf uns an.'));
        return;
      }
      if (!testMode() && duplicateSubmit(form)) {
        formMessage(form, text('duplicate', 'Diese Anfrage hast du bereits gesendet. Wir melden uns.'));
        return;
      }
      formMessage(form, '');
      resubmit(form);
    });
  }

  document.addEventListener('submit', onSubmit, true);

  function init() {
    registerRoot(document);
    scan(document);
    var rescans = 0;
    var poll = setInterval(function () {
      rescans++;
      scan(document);
      if (rescans >= 10) clearInterval(poll);
    }, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();